import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import logo from '../assets/logo.png';
import buckleImage from '../assets/buckel_image.jpeg';
import drhLogo from '../assets/DRH_cattlelogo.PNG';
import flyer from '../assets/flyer.JPG';
import logoBg from '../assets/logo-bg.png';

import { 
  FaFire, 
  FaClipboardList, 
  FaCalendarAlt, 
  FaTrophy,
  FaDollarSign,
  FaMapMarkerAlt,
  FaHammer,
  FaUtensils,
  FaBaby,
  FaCampground,
  FaMusic,
  FaStore,
  FaGift,
  FaHorse,
  FaBreadSlice,
  FaLeaf,
  FaCookie,
  FaShare,
  FaFacebook,
  FaTwitter,
  FaWhatsapp,
  FaCopy,
  FaDownload
} from 'react-icons/fa';

import { 
  GiChickenOven,
  GiMeat,
  GiBarbecue,
  GiCampfire
} from 'react-icons/gi';

import { MdEventAvailable } from 'react-icons/md';

const Home = () => {
  const handleShare = (platform) => {
    const url = window.location.href;
    const text = "Check out the Segovia BBQ Cookoff - October 25, 2025! $5,000 in prizes + $1,000 charity donation!";
    
    switch(platform) {
      case 'facebook':
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank');
        break;
      case 'twitter':
        window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`, '_blank');
        break;
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`, '_blank');
        break;
      case 'copy':
        navigator.clipboard.writeText(url).then(() => {
          alert('Link copied to clipboard!');
        });
        break;
      case 'download':
        // Create a temporary link to download the flyer
        const link = document.createElement('a');
        link.href = flyer;
        link.download = 'Segovia-BBQ-Cookoff-Flyer.jpg';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        break;
      default:
        break;
    }
  };

  return (
    <div className="home-container">
      <div className="hero-section">
        <div className="hero-background-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
        <div className="hero-content">
          <div className="logo-container">
            <img src={logo} className="logo" alt="Segovia BBQ Cookoff" />
            <div className="logo-glow"></div>
          </div>
          <div className="hero-text">
            <p className="presented-by">Presented by Segovia Events & DRH Cattle Youth Rodeo</p>
            <div className="drh-logo-container">
              <img src={drhLogo} className="drh-logo" alt="DRH Cattle Youth Rodeo" />
            </div>
            <p className="sanctioned-by">Sanctioned by the Champions Barbecue Alliance (CBA)</p>
            <div className="hero-stats">
              <div className="stat-item">
                <span className="stat-number">$5,000</span>
                <span className="stat-label">Prize Pool + $1K Charity</span>
              </div>
              <div className="stat-divider"></div>
              <div className="stat-item">
                <span className="stat-number">Oct 25</span>
                <span className="stat-label">2025</span>
              </div>
              <div className="stat-divider"></div>
              <div className="stat-item">
                <span className="stat-number">Edinburg</span>
                <span className="stat-label">Texas</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="cta-section">
        <div className="cta-buttons">
          <Link to="/register" className="btn btn-primary">
            <FaFire className="btn-icon" />
            Register Your Team
            <span className="btn-arrow">→</span>
          </Link>
          <Link to="/details" className="btn btn-secondary">
            <FaClipboardList className="btn-icon" />
            Learn More
            <span className="btn-arrow">→</span>
          </Link>
        </div>
      </div>

      <div className="info-grid">
        <div className="info-card event-info">
          <FaCalendarAlt size={15} className="card-icon" />
          <div className="card-content">
            <h2>Event Details</h2>
            <div className="event-details">
              <div className="detail-row">
                <MdEventAvailable className="detail-icon" />
                <div className="detail-content">
                  <strong>Competition Day:</strong> Saturday, October 25, 2025
                </div>
              </div>
              <div className="detail-row">
                <FaHammer className="detail-icon" />
                <div className="detail-content">
                  <strong>Setup Day:</strong> Friday, October 24, 2025
                </div>
              </div>
              <div className="detail-row">
                <FaMapMarkerAlt className="detail-icon" />
                <div className="detail-content">
                  <strong>Location:</strong> Hidalgo County Sheriff's Posse Arena, Edinburg, TX
                </div>
              </div>
              <div className="detail-row">
                <FaDollarSign className="detail-icon" />
                <div className="detail-content">
                  <strong>Prize Pool:</strong> $5,000 + $1,000 Charity!
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="info-card categories-card">
          <GiBarbecue className="card-icon" />
          <div className="card-content">
            <h2>Competition Categories</h2>
            <div className="buckle-showcase">
              <img src={buckleImage} className="buckle-image" alt="Championship Buckle" />
              <p className="buckle-text">Championship Buckle awarded to the Grand Champion!</p>
            </div>
            <div className="categories-grid">
              <div className="category-item cba-category">
                <GiChickenOven className="category-icon" />
                <div className="category-info">
                  <span className="category-name">CBA Chicken</span>
                  <span className="category-prize">$400 - 1st Place</span>
                </div>
              </div>
              <div className="category-item cba-category">
                <GiMeat className="category-icon" />
                <div className="category-info">
                  <span className="category-name">CBA Ribs</span>
                  <span className="category-prize">$400 - 1st Place</span>
                </div>
              </div>
              <div className="category-item cba-category">
                <GiMeat className="category-icon" />
                <div className="category-info">
                  <span className="category-name">CBA Brisket</span>
                  <span className="category-prize">$400 - 1st Place</span>
                </div>
              </div>
              <div className="category-item jackpot-category">
                <FaLeaf className="category-icon" />
                <div className="category-info">
                  <span className="category-name">Jackpot Beans</span>
                  <span className="category-prize">50% Payout</span>
                </div>
              </div>
              <div className="category-item jackpot-category">
                <GiMeat className="category-icon" />
                <div className="category-info">
                  <span className="category-name">Jackpot Fajita</span>
                  <span className="category-prize">50% Payout</span>
                </div>
              </div>
              <div className="category-item jackpot-category">
                <FaBreadSlice className="category-icon" />
                <div className="category-info">
                  <span className="category-name">Pan de Campo</span>
                  <span className="category-prize">50% Payout</span>
                </div>
              </div>
                <div className="category-item jackpot-category">
                <FaCookie className="category-icon" />
                <div className="category-info">
                  <span className="category-name">Dessert</span>
                  <span className="category-prize">50% Payout</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="info-card kids-card">
          <FaBaby className="card-icon" />
          <div className="card-content">
            <h2>Junior Pitmasters</h2>
            <p>Future BBQ champions start here! Join our Kids Cookoff competition.</p>
            <div className="kids-info">
              <div className="age-group">
                <span className="age-label">Junior (5-10)</span>
                <span className="age-prize">50% of Entry Pool</span>
              </div>
              <div className="age-group">
                <span className="age-label">Senior (11-17)</span>
                <span className="age-prize">50% of Entry Pool</span>
              </div>
            </div>
            <Link to="/kids-cookoff" className="inline-cta">Learn More →</Link>
          </div>
        </div>

        <div className="info-card extras-card">
          <FaCampground className="card-icon" />
          <div className="card-content">
            <h2>Event Attractions</h2>
            <p>More than just amazing BBQ - it's a full family experience!</p>
            <div className="attractions-list">
              <div className="attraction-item">
                <FaHorse className="attraction-icon" />
                <span>Youth Rodeo</span>
              </div>
              <div className="attraction-item">
                <FaStore className="attraction-icon" />
                <span>Food & Merchandise Vendors</span>
              </div>
              <div className="attraction-item">
                <FaMusic className="attraction-icon" />
                <span>Live Music & Entertainment</span>
              </div>
              <div className="attraction-item">
                <FaGift className="attraction-icon" />
                <span>Raffles & Prizes</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flyer-section">
        <div className="flyer-content">
          <h2>Event Flyer</h2>
          <p>Share this with your friends and fellow pitmasters!</p>
          <div className="flyer-container">
            <img src={flyer} className="event-flyer" alt="Segovia BBQ Cookoff Event Flyer" />
          </div>
          <div className="share-buttons">
            <h3><FaShare className="share-icon" /> Share the Event</h3>
            <div className="share-options">
              <button onClick={() => handleShare('facebook')} className="share-btn facebook">
                <FaFacebook /> Facebook
              </button>
              <button onClick={() => handleShare('twitter')} className="share-btn twitter">
                <FaTwitter /> Twitter
              </button>
              <button onClick={() => handleShare('whatsapp')} className="share-btn whatsapp">
                <FaWhatsapp /> WhatsApp
              </button>
              <button onClick={() => handleShare('copy')} className="share-btn copy">
                <FaCopy /> Copy Link
              </button>
              <button onClick={() => handleShare('download')} className="share-btn download">
                <FaDownload /> Download Flyer
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="championship-section">
        <div className="championship-content">
          <h2><FaTrophy className="championship-icon" /> Grand Championship</h2>
          <p>Compete for the ultimate BBQ glory!</p>
          <div className="championship-prizes">
            <div className="prize-item grand">
              <span className="prize-amount">$500</span>
              <span className="prize-title">Grand Champion</span>
            </div>
            <div className="prize-item reserve">
              <span className="prize-amount">$300</span>
              <span className="prize-title">Reserve Grand Champion</span>
            </div>
          </div>
          <div className="community-donation">
            <p className="donation-text">
              <FaGift className="donation-icon" />
              $5,000 in prizes PLUS $1,000 donated to local charity - supporting our community!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home; 